import React, { Fragment } from 'react'
import { FormDate, FormDisplayErrors } from '@myxplor/forms'
import { startOfWeek, dayFormat, weekFormatted } from '../../week'

const dayToMonday = onChange => (keys, value) => onChange(keys, dayFormat(startOfWeek(value)))

const ReportSummary = ({ reportName, value }) => (
  <Fragment>
    This will generate a <abbr title="CSV files can be opened in any spreadsheet program">CSV</abbr>{' '}
    report of your {reportName} from {weekFormatted(value, true)}
  </Fragment>
)

export const CCSWeekInput = ({
  reportName,
  name = 'week_start_date',
  value,
  errors,
  onChange,
  valid,
}) => (
  <div className="reportForm--dateRange">
    <FormDate
      name={name}
      label="Start date"
      hint="Monday is considered the start of the week"
      value={value}
      errors={errors}
      onChange={dayToMonday(onChange)}
      required
      today
    />

    {valid ? (
      <ReportSummary reportName={reportName} value={value} />
    ) : (
      <FormDisplayErrors
        errors={`You can only create a ${reportName} report from the 2nd July 2018 until now.`}
      />
    )}
  </div>
)



// WEBPACK FOOTER //
// ./src/reports/reports/ccs-week-input.jsx